<template>
    <v-content>
        <v-row class="pb-0 pb-sm-2">
            <v-col class="display-1">
                Аудиоролики
            </v-col>
            <v-col>
                <div class="float-right">
                    <v-btn color="primary" depressed @click="createRecord()">
                        <v-icon small>mdi-plus</v-icon>
                        Создать аудиоролик
                    </v-btn>
                    <v-btn color="info" style="margin-left: 5px" depressed @click="updateAudioList()">
                        Обновить список аудиороликов
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4">
                <v-text-field
                    v-model="name"
                    @input="getRecords"
                    placeholder="Название"
                    outlined
                    hide-details
                    clearable
                    dense
                ></v-text-field>
            </v-col>
            <v-col cols="4">
                <v-select
                  outlined
                  dense
                  hide-details
                  clearable
                  :items="mailing_accounts"
                  item-value="id"
                  item-text="name"
                  label="Аккаунт рассыльщика"
                  v-model="mailing_account_id"
                  @input="getRecords"
                />
            </v-col>
        </v-row>
        <b-table
            :data="records.results"
            :loading="isLoading"
            paginated
            backend-pagination
            :total="records.total"
            :per-page="perPage.value"
            @page-change="onPageChange"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            backend-sorting
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"
        >
            <template slot-scope="props">
                <b-table-column field="id" label="ID" centered numeric sortable>
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column field="name" label="Название" centered sortable>
                    {{ props.row.name }}
                </b-table-column>

                <b-table-column field="account_name" label="Аккаунт" centered>
                    {{ props.row.account_mailer.name }}
                </b-table-column>

                <b-table-column field="path" label="Запись" centered>
                    <audio controls :src="props.row.path"></audio>
                </b-table-column>

                <b-table-column field="created_at" label="Создано" centered sortable>
                    {{ props.row.created_at | isoToDateTime}}
                </b-table-column>

                <b-table-column
                      label="Действия"
                      style="width: 20px;"
                      centered
                  >
                  <b-tooltip
                      label="Удалить">
                      <div
                          @click="deleteRecord(props.row.id)">
                          <b-icon
                              icon="delete"
                          ></b-icon>
                      </div>
                  </b-tooltip>
                </b-table-column>
            </template>
              <template slot="bottom-left">
                <div class="pagination-controls">
                  <v-select
                    style="width: fit-content; float: left;"
                    v-model="perPage.value"
                    @change="getRecords"
                    :items="perPageOptions"
                    item-text="name"
                    item-value="value"
                    outlined
                    hide-details
                    dense
                  />
                </div>
            </template>
        </b-table>
    </v-content>
</template>

<script>
export default {
    name: 'recordsList',
    data() {
        return {
            sortField: "id",
            sortOrder: "desc",
            page: 1,
            perPage: {
                value: 20,
            },
            mailing_account_id: null,
            perPageOptions: [
                { name: "10 на странице", value: 10 },
                { name: "20 на странице", value: 20 },
                { name: "50 на странице", value: 50 },
                { name: "100 на странице", value: 100 },
            ],
            type: {
                value: null,
            },
            types: [
                { name: "Рассылки", value: 'instant' },
                { name: "Цепочки", value: 'chain' },
            ],
        }
    },
    created() {
        this.getRecords();
        this.$store.dispatch('GET_MAILING_ACCOUNT_LIST', { type_of_notification: 'call' });
    },
    computed: {
        records() {
            return this.$store.getters.RECORDS;
        },
        isLoading() {
            return this.$store.getters.RECORDS_IS_LOADING;
        },
        mailing_accounts() {
            return this.$store.getters.MAILING_ACCOUNTS_LIST.results;
        },
    },
    methods: {
        createRecord() {
          this.$router.push({ path: "/audio-list/create" });
        },
        getRecords() {
            const params = {
                sort_by: this.sortField,
                order: this.sortOrder,
                page: this.page,
                perPage: this.perPage.value,
                name: this.name,
                type: this.type.value,
                mailing_account: this.mailing_account_id,
            };
            this.$store.dispatch('GET_RECORDS', params);
        },
        deleteRecord(recordId) {
            this.$store.dispatch('DELETE_RECORD', recordId)
                .finally(() => {
                    this.$toast.success("Аудиозапись удалена!");
                    this.getRecords();
                });
        },
        onSort(field, order) {
            this.sortField = field;
            this.sortOrder = order;
            this.getRecords();
        },
        onPageChange(page) {
            this.page = page;
            this.getRecords();
        },
        filteredDataArray(data, item) {
            return data.filter((option) => {
              return option.name
                  .toString()
                  .toLowerCase()
                  .indexOf(item.name.toLowerCase()) >= 0;
            });
        },
        updateAudioList() {
            this.$store
                .dispatch("UPDATE_AUDIO_LIST")
                .then(() => {
                    this.getRecords();
                    this.$toast.success("Аудиоролики обновлены!");
                })
                .catch(() => {
                    this.$toast.error("Неизвестная ошибка!");
                });
        },
    }
}
</script>

<style>

</style>
